module.exports = __webpack_public_path__ + "static/img/eyebrows_01.23e43a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_01.png
// module id = SqC7
// module chunks = 0